import { Grid, Box, Chip, Typography } from '@mui/material';
import Psychology from '@mui/icons-material/Psychology';
import Chat from '@mui/icons-material/Chat';
import InfoItem from '../components/InfoItem';
import PromptItem from '../components/PromptItem';
import { getValue } from '../utils';

const DetailsTab = ({ behavior }) => (
  <Grid container spacing={3}>
    <InfoItem
      label='Baseline'
      value={getValue(behavior?.info?.DataCollection?.Baseline)}
      xs={12}
      sm={12}
    />

    {behavior?.info?.DataCollection?.HasInterventions === 'Yes' && (
      <Grid item xs={12}>
        <Box sx={{ mt: 2 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              mb: 1,
            }}
          >
            <Psychology fontSize='small' color='action' />
            <Typography variant='subtitle2' color='text.secondary'>
              Interventions
            </Typography>
          </Box>
          {behavior?.info?.DataCollection?.Interventions?.length > 0 ? (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {behavior.info.DataCollection.Interventions.map(
                (intervention, index) => (
                  <Chip
                    key={index}
                    label={intervention}
                    size='small'
                    sx={{
                      bgcolor: '#e9eaff',
                      color: '#2c3e50',
                      fontWeight: 500,
                      '&:hover': {
                        bgcolor: '#d8d7ff',
                      },
                    }}
                  />
                )
              )}
            </Box>
          ) : (
            <Typography variant='body2' color='text.secondary'>
              No interventions specified
            </Typography>
          )}
        </Box>
      </Grid>
    )}

    <Grid item xs={12}>
      <Box sx={{ mt: 2 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 1,
          }}
        >
          <Typography variant='subtitle2' color='text.secondary'>
            Prompting Applicable:{' '}
            {getValue(
              behavior?.info?.DataCollection?.PromptingApplicable
                ?.isPromptingApplicable
            )}
          </Typography>
        </Box>

        {behavior?.info?.DataCollection?.PromptingApplicable
          ?.isPromptingApplicable ? (
          <>
            <Typography
              variant='subtitle2'
              color='text.secondary'
              sx={{ mb: 1 }}
            >
              Prompting Type:{' '}
              {getValue(
                behavior?.info?.DataCollection?.PromptingApplicable
                  ?.PromptingType
              )}
            </Typography>

            {behavior?.info?.DataCollection?.PromptingApplicable
              ?.PromptingType === 'IVP, DVP, PVP, GP, PP' && (
              <Grid container spacing={1}>
                {['I', 'VP', 'IVP', 'DVP', 'PVP', 'GP', 'PP'].map((prompt) => (
                  <PromptItem
                    key={prompt}
                    label={prompt}
                    value={getValue(
                      behavior?.info?.DataCollection?.PromptingApplicable?.[
                        prompt
                      ]
                    )}
                  />
                ))}
              </Grid>
            )}

            {behavior?.info?.DataCollection?.PromptingApplicable
              ?.PromptingType === 'P+ & P-' && (
              <Grid container spacing={2}>
                <PromptItem
                  label='P+'
                  value={getValue(
                    behavior?.info?.DataCollection?.PromptingApplicable?.pPlus
                  )}
                  xs={6}
                />
                <PromptItem
                  label='P-'
                  value={getValue(
                    behavior?.info?.DataCollection?.PromptingApplicable?.pMinus
                  )}
                  xs={6}
                />
              </Grid>
            )}
          </>
        ) : (
          <Typography variant='body2'> No </Typography>
        )}
      </Box>
    </Grid>

    <Grid item xs={12}>
      <Box sx={{ mt: 2 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mb: 1,
          }}
        >
          <Chat fontSize='small' color='action' />
          <Typography variant='subtitle2' color='text.secondary'>
            Notes
          </Typography>
        </Box>
        <Typography variant='body2' sx={{ whiteSpace: 'pre-line' }}>
          {getValue(behavior?.info?.DataCollection?.Notes)}
        </Typography>
      </Box>
    </Grid>
  </Grid>
);

export default DetailsTab;

